import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import translations from "../../../text/get-started-translations.json";
import language from '../../../utils/LanguageSettings';

const ChannelCategory: React.FC<{ onCategoryChange: (category: string) => void }> = ({ onCategoryChange }) => {
  const pageTranslations = translations[language];

  const getInitialCategory = () => {
    if (window.myAppStrapi && window.myAppStrapi.urlHash) {
      return window.myAppStrapi.urlHash === "#on-demand" ? "on-demand" : "channel";
    }
    return window.location.hash === "#on-demand" ? "on-demand" : "channel";
  };

  const [activeCategory, setActiveCategory] = useState<string>(getInitialCategory());

  useEffect(() => {
    setActiveCategory(getInitialCategory());
  }, []);

  const handleCategoryClick = (category: string) => {
    setActiveCategory(category);
    onCategoryChange(category);
  };

  return (
    <div className="channel-category row">
      <div className="channel-type">
        <Link
          to="#channel"
          className={`text-16 ${activeCategory === "channel" ? "active" : ""}`}
          data-target="channel"
          onClick={() => handleCategoryClick("channel")}
        >
          {pageTranslations.Channel}
        </Link>
        <Link
          to="#on-demand"
          className={`text-16 ${activeCategory === "on-demand" ? "active" : ""}`}
          data-target="on-demand"
          onClick={() => handleCategoryClick("on-demand")}
        >
          {pageTranslations.OnDemand}
        </Link>
      </div>
    </div>
  );
};

export default ChannelCategory;
